import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ClickAwayListener, IconButton, styled, Tooltip} from "@mui/material";
import {FormattedMessage, IntlShape, useIntl} from "react-intl";
import {useBoolState} from "../../../hooks";
import {DeviceSetLimitSummary, deviceTranslations} from "./utils";

type Props = {
    deviceSetLimitSummary: DeviceSetLimitSummary;
};

const FontSizeContainer = styled("div")({
    fontSize: "0.75rem",
});

const UnlimitedOrValue = ({limit}: {limit: number | null}) => {
    console.log("UnlimitedOrValue", limit);
    return limit === null ? <FormattedMessage id="unlimited" defaultMessage="Unlimited" /> : limit;
};

const EmptyDevicesList = () => (
    <FormattedMessage id="no_remaining_device_quotas" defaultMessage="There are no remaining device quotas" />
);

const DevicesList = ({devicesInfo, intl}: {devicesInfo: DeviceSetLimitSummary; intl: IntlShape}) =>
    devicesInfo.remainingLimits.map((limit, index) => {
        const devices = limit.devices.map((device) => intl.formatMessage(deviceTranslations[device])).join(" / ");
        return (
            <p key={index}>
                {devices}: <UnlimitedOrValue limit={limit.limit} />
            </p>
        );
    });

const Title = ({devicesInfo}: {devicesInfo: DeviceSetLimitSummary}) => {
    const intl = useIntl();

    return (
        <FontSizeContainer>
            <p>
                <strong>
                    <FormattedMessage id="remaining_device_quotas" defaultMessage="Remaining device quotas" />
                </strong>
            </p>
            {devicesInfo.remainingLimits.length === 0 && <EmptyDevicesList />}
            {devicesInfo.remainingLimits.length > 0 && <DevicesList devicesInfo={devicesInfo} intl={intl} />}
        </FontSizeContainer>
    );
};

const DevicesTooltip = ({deviceSetLimitSummary: devicesInfo}: Props) => {
    const [isOpen, open, close] = useBoolState();

    return (
        <ClickAwayListener onClickAway={close}>
            <span style={{borderBottom: `2px solid #e8e8e8`, padding: 10}}>
                <Tooltip
                    title={<Title devicesInfo={devicesInfo} />}
                    placement="bottom"
                    arrow
                    disableFocusListener
                    disableTouchListener
                    disableHoverListener
                    onClose={close}
                    open={isOpen}
                >
                    <IconButton onClick={open} size="small" color="primary">
                        <FontAwesomeIcon icon="info-circle" />
                    </IconButton>
                </Tooltip>
            </span>
        </ClickAwayListener>
    );
};

export default DevicesTooltip;
